import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import ContributionFormPresenter from "./ContributionFormPresenter";

class ContributionFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      computation: null,
      roundUp: false,
      roundDown: false,
    };
    this.presenter = new ContributionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "contribution_type";
  }

  getStateComputation() {
    return this.state.computation;
  }
  getStateCheckbox() {
    return this.state.roundUp || this.state.roundDown;
  }

  // async componentDidMount() {
  //   this.presenter.componentDidMount();
  //   const allRegion = await findObjectUseCase().execute("Region");
  //   const region = allRegion.filter((data) => data.status === "active");
  //   this.setState({ region });
  // }

  componentDidUpdate(prevProps, prevState) {
    const { object } = this.state;
    if (prevState.object !== this.state.object) {
      this.method();
    }
  }

  async method() {
    const { object } = this.state;
    // Always set the state from object if it exists, even if contribution_method is null
    if (object && (object.contribution_method !== undefined || object.roundDown !== undefined || object.roundUp !== undefined)) {
      this.setState({
        computation: object.contribution_method || null,
        roundDown: object.roundDown || false,
        roundUp: object.roundUp || false,
      });
    }
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleComputationChange = async (computation) => {
    this.setState({ computation });
    // Update the object so it's saved properly
    const updatedObject = {
      ...this.state.object,
      contribution_method: computation,
    };

    console.log("updatedObject", updatedObject);
    this.onChangeObject(updatedObject);
  };

  handleCheckBox(field) {
    this.setState((prevState) => {
      const newState = {
        roundUp: field === "roundUp" ? !prevState.roundUp : false,
        roundDown: field === "roundDown" ? !prevState.roundDown : false,
      };

      const updatedObject = {
        ...prevState.object,
        roundUp: newState.roundUp,
        roundDown: newState.roundDown,
      };
      console.log("UPDATEDD OBJECT", updatedObject);
      this.onChangeObject(updatedObject);

      return newState;
    });
  }

  render() {
    const object = this.state.object;
    const computation = ["INPUT AMOUNT", "FIX AMOUNT", "FORMULA"];

    console.log("object", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="p-0">
                          <label>
                            Contribution Type{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="contributionType"
                            object={object}
                            // placeholder="name"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>

                        <div className="p-0">
                          <label>
                            Computation Method{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <SearchSelect
                            value={this.state.computation}
                            onChange={this.handleComputationChange}
                            options={computation.map((computation) => ({
                              label: computation,
                              value: computation,
                            }))}
                          />
                        </div>

                        {this.state.computation === "FIX AMOUNT" && (
                          <div className="p-0">
                            <label>
                              Enter Fix Amount{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <InputFactory
                              type="String"
                              _type="DecemalNum"
                              field="fix"
                              object={object}
                              // placeholder="description"
                              onChange={this.onChange.bind(this)}
                              required={true}
                            />
                          </div>
                        )}
                        {this.state.computation === "FORMULA" && (
                          <div className="p-0">
                            <label>
                              Enter Formula{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <InputFactory
                              type="String"
                              field="formula"
                              object={object}
                              // placeholder="description"
                              onChange={this.onChange.bind(this)}
                              required={true}
                            />
                            <p style={{ margin: "0", paddingTop: "5px" }}>
                              You can use <strong>`monthly_rate`</strong>{" "}
                              keyword as Monthly Rate of the employee.
                            </p>
                            <div className="d-flex gap-2 ">
                              <label>
                                <input
                                  style={{
                                    accentColor: "#0038A8",
                                  }}
                                  object={object}
                                  type="checkbox"
                                  onChange={() =>
                                    this.handleCheckBox("roundUp")
                                  }
                                  checked={this.state.roundUp}
                                  name="roundUp"
                                />{" "}
                                Round Up
                              </label>
                              <label>
                                <input
                                  style={{
                                    accentColor: "#0038A8",
                                  }}
                                  object={object}
                                  type="checkbox"
                                  onChange={() =>
                                    this.handleCheckBox("roundDown")
                                  }
                                  checked={this.state.roundDown}
                                  name="roundUp"
                                />{" "}
                                Round Down
                              </label>
                            </div>
                          </div>
                        )}

                        <div className="p-0">
                          <label>
                            Description <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="description"
                            object={object}
                            placeholder="description"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ContributionFormPage);
